/* eslint-disable import/no-anonymous-default-export */

import { useContext, useCallback } from 'react';
import _get from 'lodash/get';
import _map from 'lodash/map';
import _chunk from 'lodash/chunk';
import _filter from 'lodash/filter';
import { AjaxContext, formatListData } from 'commons-ui';

import { UserlistData } from './constants';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const getCouponData = useCallback(
		async ({
			app,
			pageDetails,
			sortDetails,
			filterDetails
		}: {
			app: any;
			pageDetails: any;
			sortDetails: any;
			filterDetails: any;
		}) => {
			const { isGold, appName } = app;
			const response = await postData({
				endpoint: '/marketing/dashboard/coupon/getCoupons',
				body: {
					page: pageDetails,
					filters: filterDetails,
					sortInfoArray: sortDetails,
					isPartnerCoupon: false,
					isGold
				},
				queryParams: {
					appName
				}
			});
			let listData = formatListData(response?.data?.coupons);
			listData = _filter(listData, (row) => !_get(row, 'isPartnerCoupon', false));
			return { rowCount: response?.data?.count, data: listData };
		},
		[]
	);

	const requestCreateCoupon = useCallback((appName: string, data: any) => {
		return postData({
			endpoint: '/marketing/dashboard/coupon/createCoupon',
			body: { ...data, isGold: data.isGold },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestUpdateCoupon = useCallback((appName: string, data: any) => {
		return postData({
			endpoint: '/marketing/dashboard/coupon/updateCoupon',
			body: { ...data, isGold: data.isGold },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestAddUserlist = useCallback((appName: any, data: UserlistData) => {
		const { uids, maxRedemptions, code } = data;

		return Promise.all(
			_map(_chunk(uids, 5000), (chunk) =>
				postData({
					endpoint: '/marketing/dashboard/coupon/addUsersToCoupon',
					body: { uids: chunk, maxRedemptions, code },
					queryParams: {
						appName
					}
				})
			)
		);
	}, []);
	const toggleIsDisabledField = useCallback(async (rowData: any, history: any, user: any, app: any, showAlert: any) => {
		const data = rowData;
		data.isDisabled = !data.isDisabled;

		try {
			const response = await requestUpdateCoupon(app.appName, { ...data, updatedBy: _get(user, 'userName', '') });

			if (response.status !== 200 || !response.data.success) {
				showAlert(response.data.error || 'Error occured while toggling isDisabled field', { type: 'error' });
				return;
			}
			showAlert('isDisabled field toggled');
		} catch (error: any) {
			data.isDisabled = !data.isDisabled;
			showAlert(error.response.data.error || 'Error occured while toggling isDisabled field', { type: 'error' });
		}
	}, []);

	return {
		getCouponData,
		requestAddUserlist,
		requestUpdateCoupon,
		requestCreateCoupon,
		toggleIsDisabledField
	};
};

export default useService;
